import { styled } from '@mui/material';
import React from 'react';
import { kiwiGreen, spaceCadet } from '../../../../utils/colors';

interface IndicatorProps extends React.HTMLProps<HTMLDivElement> {
  sessionId?: string;
}

const Indicator = styled((props: IndicatorProps) => {
  const { sessionId, ...other } = props;
  return <div {...other} />;
})(({ theme, sessionId }) => ({
  display: 'block',
  '@keyframes alarm': {
    '0%': {
    },
    '50%': {
      boxShadow: `0px 0px 4px ${kiwiGreen['500']}, 0px 0px 4px ${kiwiGreen['500']}`,
    },
    '100%': {
    },
  },
  ...(sessionId && { animation: 'alarm 3000ms cubic-bezier(0.25, 0.1, 0.25, 1) infinite' }),
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.standard,
  }),
  marginLeft: 4,
  width: 6,
  height: 6,
  backgroundColor: sessionId ? kiwiGreen[500] : spaceCadet[400],
  borderRadius: '50%',
}));

function ListeningIndicator(props: { sessionId?: string }) {
  const { sessionId } = props;

  return <Indicator sessionId={sessionId} />;
}

export default ListeningIndicator;
